<template>
  <div :id="id" class="modal fade modalDelete" tabindex="-1" aria-labelledby="deleteModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 mt-sm-3">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">
                    <img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" />
                  </span>
                </button>
              </div>
              <div class="col-12 text-center">
                <img :src="require('../../../public/src/images/' + image)" :alt="image" />
                <h3 class="modal-title mt-2">{{ headerText }} {{ id === "deleteModal" ? "Silme" : null }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <template v-if="modalType === 'delete'">
                <div class="col-12">
                  <p class="text-center">
                    <strong>{{ innerText }}</strong>
                    {{ entityTitle }}
                    <br />
                    {{ modalText }}
                  </p>
                </div>
              </template>
              <template v-else-if="modalType === 'warning'">
                <div class="col-12">
                  <p class="text-center">
                    {{ warningModalContent }}
                  </p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer mb-4">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 text-center">
                <template v-if="modalType === 'delete'">
                  <loading :active="loadingBtnState === 'deleteEntity'" :is-full-page="false" class="btnLoading" />
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Hayır</button>
                  <base-button :btn-text="'Evet'" :spinner="loadingBtnState === 'deleteEntity'" data-dismiss="modal" @click.native="deleteEntity()" />
                </template>
                <template v-else-if="modalType === 'warning'">
                  <button type="button" class="btn btn-primary" data-dismiss="modal">Tamam</button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import baseButton from "../element/buttons/BaseButton";

export default {
  name: "BaseModalComponent",

  components: {
    Loading,
    BaseButton: baseButton,
  },
  props: {
    loadingBtnState: {
      type: String,
      default: null,
    },
    loadingHistory: {
      type: String,
      default: null,
    },
    entityTitle: {
      type: String,
      default: null,
    },
    modalText: {
      type: String,
      default: null,
    },
    warningModalText: {
      type: String,
      default: null,
    },
    modalType: {
      type: String,
      default: "delete",
    },
    //  interpolation
    headerText: {
      type: String,
      default: null,
    },
    innerText: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
  computed: {
    warningModalContent: {
      get() {
        return this.$store.getters.getWarningModalContent;
      },
    },
  },
  methods: {
    deleteEntity() {
      this.$emit("deleteEntity", this.loadingBtnState);
    },
  },
};
</script>

<style scoped></style>
